export class Generic {
    public idResultado: number;
    public list: any;
    public resultado: string;
    public value: string;
    public values: any;

    constructor(){}
}
